/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tier_Cta_FreeInputs */

const en_tier_cta_free = /** @type {(inputs: Tier_Cta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initialize Free`)
};

const es_tier_cta_free = /** @type {(inputs: Tier_Cta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicializar Gratis`)
};

const fr_tier_cta_free = /** @type {(inputs: Tier_Cta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initialiser Gratuitement`)
};

const de_tier_cta_free = /** @type {(inputs: Tier_Cta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos initialisieren`)
};

const ja_tier_cta_free = /** @type {(inputs: Tier_Cta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料で初期化する`)
};

const zh_tier_cta_free = /** @type {(inputs: Tier_Cta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费初始化`)
};

const ar_tier_cta_free = /** @type {(inputs: Tier_Cta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تهيئة مجانية`)
};

const id_tier_cta_free = /** @type {(inputs: Tier_Cta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inisialisasi Gratis`)
};

const it_tier_cta_free = /** @type {(inputs: Tier_Cta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizializzazione Gratuita`)
};

const ru_tier_cta_free = /** @type {(inputs: Tier_Cta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать бесплатно`)
};

const pt_tier_cta_free = /** @type {(inputs: Tier_Cta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar Gratuitamente`)
};

const ko_tier_cta_free = /** @type {(inputs: Tier_Cta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료로 시작하기`)
};

/**
* | output |
* | --- |
* | "Initialize Free" |
*
* @param {Tier_Cta_FreeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tier_cta_free = /** @type {((inputs?: Tier_Cta_FreeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tier_Cta_FreeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tier_cta_free(inputs)
	if (locale === "es") return es_tier_cta_free(inputs)
	if (locale === "fr") return fr_tier_cta_free(inputs)
	if (locale === "de") return de_tier_cta_free(inputs)
	if (locale === "ja") return ja_tier_cta_free(inputs)
	if (locale === "zh") return zh_tier_cta_free(inputs)
	if (locale === "ar") return ar_tier_cta_free(inputs)
	if (locale === "id") return id_tier_cta_free(inputs)
	if (locale === "it") return it_tier_cta_free(inputs)
	if (locale === "ru") return ru_tier_cta_free(inputs)
	if (locale === "pt") return pt_tier_cta_free(inputs)
	return ko_tier_cta_free(inputs)
});